// extracted by mini-css-extract-plugin
module.exports = {"bgContainer":"Ki","footer":"Li","screenReadersOnly":"Mi","nav":"Ni"};